import ConfirmationPage from '@/components/service-log/history/confirmation-page/confirmation-page.vue';

export default {
  name: 'SubmissionHistory',
  props: ['submission', 'fromDashboard'],
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  components: {
    ConfirmationPage
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    slDeleted() {
      this.dialog = false;
      this.$emit('reload:page');
    }
  },
  mounted() {
    this.dialog = true;
  },
  watch: {
    dialog() {
      if (!this.dialog) this.$emit('dialog:closed');
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/service-log/history/submission-history-dialog/submission-history-dialog.js